<template>
    <v-col cols="12" md="3" ma-1>
        <v-card>
            <v-card-title class="title font-weight-black">
                <v-icon class="pr-3">reviews</v-icon> Review
            </v-card-title>

            <v-card-text>
                <v-container fluid>
                    <v-row>
                        <v-col>
                            <v-btn class="mt-1" 
                                   block 
                                   :href="overviewUrl">Overview</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   :href="detailedReviewsUrl">Detailed Review</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   :href="guestReviewsUrl" 
                                   disabled 
                                   href="">Guest Reviews</v-btn>
                            <v-btn class="mt-1" 
                                   block
                                   :disabled="!hotel.bookable_via_iescape && !hotel.bookable_via_partner && !hotel.bookable_via_direct" 
                                   :href="starRatingsUrl">Star Ratings</v-btn>
                            <v-btn class="mt-1" 
                                   block 
                                   :disabled="!hotel.bookable_via_iescape && !hotel.bookable_via_partner && !hotel.bookable_via_direct" 
                                   :href="awardsUrl" disabled href="">Awards</v-btn>
                            <v-btn v-if="isTailormadeTour" 
                                   class="mt-1" 
                                   block 
                                   :href="operatorWriteupsUrl">Operator Writeup</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    /**
     * Display buttons linking through to a hotels' pages
     */
    export default {
        props:['results'],

        data: function() {
            return {
                isTailormadeTour: null,
                overviewUrl: '',
                detailedReviewsUrl: '',
                guestReviewsUrl: '',
                starRatingsUrl: '',
                pressReviewsUrl: '',
                awardsUrl: '',
                marketingUrl: '',
                operatorWriteupsUrl: '',
                hotel: null
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){
            this.isTailormadeTour = this.results.data[0].is_tailormade_tour;
            // Extract the hotel ID from the result set passed into this panel from the dashboard
            var hotelKey = this.results.data[0].hotel_key;
            this.detailedReviewsUrl = "/hotels/" + hotelKey + "/detailed-review";
            this.starRatingsUrl = "/hotels/" + hotelKey + "/ratings";
            this.pressReviewsUrl = "/hotels/" + hotelKey + "/press";
            this.awardsUrl = "/hotels/" + hotelKey + "/awards/list";
            // @todo this is hotel id not the writeup id which is going to be needed to look up from an api end point since its not supplied with page data
            this.overviewUrl = "/hotels/" + hotelKey + "/overview";
            this.operatorWriteupsUrl = "/hotels/" + hotelKey + "/operator-writeups";

            this.loadHotel();
        },

        methods: {

            loadHotel: function(){
                try {
                    // Extract the hotel ID from the result set passed into this panel from the dashboard
                    var hotelKey = this.results.data[0].hotel_key;

                    axios.get('/api/hotel/' + hotelKey + '/summary-information')
                        .then(function(response){
                            this.hotel = response.data.hotel;
                            this.loading = false;
                        }.bind(this));
                    }
                catch(exception){
                    console.log(exception);
                    this.hasProblem = true;
                }
            },

        }
    }
</script>

